import * as http from '@/api/config';

/* 获取活动 */
export function getAdminActivityList(data) {
    const url = 'activity/admin/v1/activity/list';
    return http.$get(url, data);
}
/* 活动详情 */
export function getAdminActivityInfo(uuid) {
    const url = 'activity/admin/v1/activity/info/' + uuid;
    return http.$get(url);
}
/* 新增活动 */
export function createAdminActivity(data) {
    const url = 'activity/admin/v1/activity/create';
    return http.$post(url, data);
}
/* 编辑活动 */
export function updateAdminActivity(type, uuid, data) {
    const url = 'activity/admin/v1/activity/update/' + uuid;
    return http.$put(url, {
        ...data,
        type: type,
    });
}
/* 编辑活动海报 */
export function updateAdminActivityPoster(uuid, data) {
    const url = 'activity/admin/v1/activity/update/' + uuid;
    return http.$put(url, {
        ...data,
        type: 'poster',
    });
}
/* 关闭活动 */
export function closeAdminActivity(uuid) {
    const url = 'activity/admin/v1/activity/close/' + uuid;
    return http.$put(url);
}
/* 发布活动 */
export function publishAdminActivity(uuid) {
    const url = 'activity/admin/v1/activity/publish/' + uuid;
    return http.$put(url);
}
/* 复制活动 */
export function copyAdminActivity(uuid) {
    const url = 'activity/admin/v1/activity/copy/' + uuid;
    return http.$post(url);
}
/* 删除活动 */
export function deleteAdminActivity(uuid) {
    const url = 'activity/admin/v1/activity/delete/' + uuid;
    return http.$delete(url);
}
/* 获取活动详情 */
export function getHomeActivityInfo(uuid) {
    const url = 'activity/home/v1/activity/info/' + uuid;
    return http.$get(url);
}



// WEBPACK FOOTER //
// ./src/api/module/activity.js